import React from "react";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import {
  initialValues,
  validationSchema,
} from "../../../validation/NewEmployeesValidation";
import TextFieldWrapper, { Selectwrapper } from "../../../components/TextField";
import { useHistory, useRouteMatch } from "react-router";
const NewEmployee = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(values, submitProps) => {
        submitProps.resetForm();
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Paper style={{ width: "100%" }}>
              <Grid
                item
                container
                xs={12}
                style={{ margin: "auto" }}
                spacing={2}
              >
                <Grid item xs={12}>
                  <Typography variant="body1">کارمند جدید</Typography>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid
                    justifyContent="center"
                    item
                    container
                    xs={12}
                    sm={5}
                    spacing={3}
                    style={{ margin: "auto" }}
                  >
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="name"
                        label="نام و نام خانوادگی"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper name="email" label="ایمیل" />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="password"
                        label="پسورد"
                        type="password"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper name="mobile" label="موبایل" />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper name="phone" label="شماره ثابت" />
                    </Grid>
                    <Grid
                      item
                      container
                      xs={12}
                      justifyContent="space-between"
                      style={{ margin: "auto" }}
                      spacing={1}
                    >
                      <Grid item xs={6}>
                        <Selectwrapper
                          label="گروه کاربری"
                          name="user_group"
                          options={user_group_Options}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Selectwrapper
                          label="وضعیت"
                          name="status"
                          options={status_Options}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      spacing={1}
                      style={{ margin: "auto" }}
                      xs={12}
                      justifyContent="space-between"
                    >
                      <Grid item xs={6}>
                        <Button
                          onClick={() => {
                            history.push(`${path}/newEmployeeShow`);
                          }}
                          type="submit"
                          disabled={!formik.isValid}
                          fullWidth
                          variant="contained"
                          color="primary"
                        >
                          ذخیره
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          انصراف
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default NewEmployee;
const user_group_Options = [
  { title: "کارمند", value: "employee" },
  { title: "مدیر", value: "manager" },
];
const status_Options = [
  { title: "کارمند", value: "employee" },
  { title: "مدیر", value: "manager" },
];
